/** @module Enums */ /** typedoc */
var NotificationTypeEnum;
(function (NotificationTypeEnum) {
    NotificationTypeEnum["Expiration"] = "expiration";
    NotificationTypeEnum["Invitation"] = "invitation";
    NotificationTypeEnum["ReferralInviteeConverted"] = "referralInviteeConverted";
    NotificationTypeEnum["Listen"] = "listen";
    NotificationTypeEnum["Master"] = "master";
    NotificationTypeEnum["Message"] = "message";
    NotificationTypeEnum["Preview"] = "preview";
    NotificationTypeEnum["Payment"] = "payment";
    NotificationTypeEnum["PaymentConfirmation"] = "paymentConfirmation";
    NotificationTypeEnum["PaymentFailed"] = "paymentFailed";
    NotificationTypeEnum["PaymentFailureInitialSkipped"] = "paymentFailureInitialSkipped";
    NotificationTypeEnum["PaymentSkipped"] = "paymentSkipped";
    NotificationTypeEnum["PaymentSuspended"] = "paymentSuspended";
    NotificationTypeEnum["PayoutCompleted"] = "payoutCompleted";
    NotificationTypeEnum["ProjectCollaboratorInvited"] = "projectCollaboratorInvited";
    NotificationTypeEnum["ProjectCollaboratorJoined"] = "projectCollaboratorJoined";
    NotificationTypeEnum["ReleaseAccepted"] = "releaseAccepted";
    NotificationTypeEnum["ReleaseLiveApple"] = "releaseLiveApple";
    NotificationTypeEnum["ReleaseLiveSpotify"] = "releaseLiveSpotify";
    NotificationTypeEnum["ReleaseLive"] = "releaseLive";
    NotificationTypeEnum["ReleasePaused"] = "releasePaused";
    NotificationTypeEnum["ReleasePlayCount"] = "releasePlayCount";
    NotificationTypeEnum["ReleaseRejected"] = "releaseRejected";
    NotificationTypeEnum["ReleaseShareReady"] = "releaseShareReady";
    NotificationTypeEnum["ReminderInvitation"] = "reminderInvitation";
    NotificationTypeEnum["RequestShareAccess"] = "requestShareAccess";
    NotificationTypeEnum["ShareReaction"] = "shareReaction";
    NotificationTypeEnum["AssetCollaboratorInvited"] = "assetCollaboratorInvited";
    NotificationTypeEnum["TrackInvitationReminder"] = "trackInvitationReminder";
    NotificationTypeEnum["AssetCommentCreated"] = "assetCommentCreated";
    NotificationTypeEnum["AlbumReady"] = "albumReady";
    NotificationTypeEnum["Unsupported"] = "unsupported";
})(NotificationTypeEnum || (NotificationTypeEnum = {}));
var NotificationCategoryEnum;
(function (NotificationCategoryEnum) {
    NotificationCategoryEnum["Billing"] = "billing";
    NotificationCategoryEnum["Collaboration"] = "collaboration";
    NotificationCategoryEnum["Referral"] = "referral";
    NotificationCategoryEnum["Distribution"] = "distribution";
    NotificationCategoryEnum["Mastering"] = "mastering";
    NotificationCategoryEnum["Promotion"] = "promotion";
    NotificationCategoryEnum["Unsupported"] = "unsupported";
})(NotificationCategoryEnum || (NotificationCategoryEnum = {}));
// For Analytics
var NotificationCategoryFromTypeEnum;
(function (NotificationCategoryFromTypeEnum) {
    NotificationCategoryFromTypeEnum["Expiration"] = "collaboration";
    NotificationCategoryFromTypeEnum["Invitation"] = "collaboration";
    NotificationCategoryFromTypeEnum["Listen"] = "collaboration";
    NotificationCategoryFromTypeEnum["Master"] = "mastering";
    NotificationCategoryFromTypeEnum["Message"] = "collaboration";
    NotificationCategoryFromTypeEnum["Payment"] = "billing";
    NotificationCategoryFromTypeEnum["PaymentFailed"] = "billing";
    NotificationCategoryFromTypeEnum["PaymentFailureInitialSkipped"] = "billing";
    NotificationCategoryFromTypeEnum["PaymentSkipped"] = "billing";
    NotificationCategoryFromTypeEnum["PaymentSuspended"] = "billing";
    NotificationCategoryFromTypeEnum["PayoutCompleted"] = "billing";
    NotificationCategoryFromTypeEnum["Preview"] = "mastering";
    NotificationCategoryFromTypeEnum["ProjectCollaboratorInvited"] = "collaboration";
    NotificationCategoryFromTypeEnum["ProjectCollaboratorJoined"] = "collaboration";
    NotificationCategoryFromTypeEnum["ReferralInviteeConverted"] = "referral";
    NotificationCategoryFromTypeEnum["ReleaseAccepted"] = "distribution";
    NotificationCategoryFromTypeEnum["ReleaseLive"] = "distribution";
    NotificationCategoryFromTypeEnum["ReleaseLiveApple"] = "distribution";
    NotificationCategoryFromTypeEnum["ReleaseLiveSpotify"] = "distribution";
    NotificationCategoryFromTypeEnum["ReleasePaused"] = "distribution";
    NotificationCategoryFromTypeEnum["ReleasePlayCount"] = "distribution";
    NotificationCategoryFromTypeEnum["ReleaseRejected"] = "distribution";
    NotificationCategoryFromTypeEnum["ReleaseShareReady"] = "promotion";
    NotificationCategoryFromTypeEnum["ReminderInvitation"] = "collaboration";
    NotificationCategoryFromTypeEnum["RequestShareAccess"] = "collaboration";
    NotificationCategoryFromTypeEnum["ShareReaction"] = "collaboration";
    NotificationCategoryFromTypeEnum["AssetCollaboratorInvited"] = "collaboration";
    NotificationCategoryFromTypeEnum["AssetCommentCreated"] = "collaboration";
    NotificationCategoryFromTypeEnum["TrackInvitationReminder"] = "collaboration";
    // AlbumReady = NotificationCategoryEnum.Mastering, TODO: check in which category to put
    NotificationCategoryFromTypeEnum["Unsupported"] = "unsupported";
})(NotificationCategoryFromTypeEnum || (NotificationCategoryFromTypeEnum = {}));

export { NotificationCategoryEnum, NotificationCategoryFromTypeEnum, NotificationTypeEnum };
